/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusEmailVorlageDetailDto } from '../../models/lexplus-email-vorlage-detail-dto';

export interface EmailTemplateControllerFindOneV1$Params {
  id: string;
}

export function emailTemplateControllerFindOneV1(http: HttpClient, rootUrl: string, params: EmailTemplateControllerFindOneV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusEmailVorlageDetailDto>> {
  const rb = new RequestBuilder(rootUrl, emailTemplateControllerFindOneV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusEmailVorlageDetailDto>;
    })
  );
}

emailTemplateControllerFindOneV1.PATH = '/v1/email-templates/{id}';
